import TournamentSideTabInfos from '@features/tournament-details/tournament-side/tournament-side';
export default TournamentSideTabInfos;
